import constant from '../constants/whereIsthisConstant';

export const whereIsthisInitialState = {
    coordinate: null,
    selectedFeatures:[],
    selectedObjectType: "",
    selectedCategories: [],
    isFeedBack: false,
    selectedAddressData: false,
    isLoading: false,
    loadingCustomerTable: false,
    isReloadTreeStructure: false,
    isDrawOpen:false
}

export function whereIsThisReducer(state, action) {

    switch (action.type) {

        case constant.WHERE_IS_tHIS_CHANGE:
            return {
                ...state,
                coordinate: action.payload
            };
        case constant.SELECTED_OBJECT_TYPE:
            return {
                ...state,
                selectedObjectType: action.payload
            };
        case constant.GET_USE_ISFEEDBACK:
            return {
                ...state,
                isFeedBack: action.payload
            };
        case constant.SET_SELECTED_FEATURES:
            return {
                ...state,
                selectedFeatures: action.payload
            };
        case constant.SELECTED_ADDRESS_DATA:
            return {
                ...state,
                selectedAddressData: action.payload
            };
        case constant.SHOW_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case constant.RELOAD_CUSTOMER_TABLE:
            return {
                ...state,
                loadingCustomerTable: action.payload
            };

        case constant.RELOAD_TREE_STRUCTURE:
            return {
                ...state,
                isReloadTreeStructure: action.payload
            };
        case constant.SET_DRAWOPEN:
            return {
                ...state,
                isDrawOpen: action.payload
            };
        default:
            return state;
    }
}

export default whereIsThisReducer;
